import { defineComponent as l, computed as a, useId as d, createBlock as p, openBlock as f, unref as e, withCtx as r, createTextVNode as v, toDisplayString as g, createVNode as _, mergeProps as x } from "vue";
import { RevTooltip as b } from "@ds/components/Tooltip";
import h from "../../../icons/generated/IconInfo.vue2.js";
import { tw as w } from "../../../utils/tailwind.js";
const z = /* @__PURE__ */ l({
  name: "RevHint",
  __name: "Hint",
  props: {
    content: {}
  },
  setup(o) {
    const c = o, i = a(() => c.content.length > 200), u = a(() => i.value ? w`sm:w-240 sm:max-w-240` : ""), t = d();
    return (C, F) => (f(), p(e(b), {
      id: e(t),
      "aria-hidden": "",
      class: "z-10",
      "content-class-names": u.value
    }, {
      trigger: r(({ show: n, hide: s, ...m }) => [
        _(e(h), x({
          "aria-describedby": e(t),
          class: "text-action-default-low",
          size: "16"
        }, m, {
          onFocusin: n,
          onFocusout: s,
          onMouseleave: s,
          onMouseover: n
        }), null, 16, ["aria-describedby", "onFocusin", "onFocusout", "onMouseleave", "onMouseover"])
      ]),
      default: r(() => [
        v(" " + g(o.content), 1)
      ]),
      _: 1
    }, 8, ["id", "content-class-names"]));
  }
});
export {
  z as default
};
